import React from 'react';
import { useNavigate } from 'react-router-dom';
import TravelerMultiStepRegistrationForm from '@/components/TravelerMultiStepRegistrationForm';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const TravelerRegistrationPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 py-12 px-4">
      {/* Back Button */}
      <div className="max-w-3xl mx-auto mb-6">
        <Button
          variant="ghost"
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-slate-600 hover:text-slate-900"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna alla Home
        </Button>
      </div>

      {/* Registration Form */}
      <TravelerMultiStepRegistrationForm />

      {/* Info Footer */}
      <div className="max-w-3xl mx-auto mt-8 text-center">
        <p className="text-sm text-slate-600">
          Hai già un account?{' '}
          <button
            onClick={() => navigate('/login')}
            className="text-blue-600 font-semibold hover:text-blue-700 hover:underline"
          >
            Accedi ora
          </button>
        </p>
      </div>
    </div>
  );
};

export default TravelerRegistrationPage;